module.exports = __webpack_public_path__ + "img/dne-international.80facf36.jpg";